import Api from "../lib/api";

class LoadMoreObserverTemplates {
	static spinner() {
		return (`
			<div class="posts_spinner" data-observer-elem="trigger">
				<div class="spinner">
					<svg class="spinner_svg" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle opacity=".1" cx="16" cy="16" r="14" stroke="#4ED401" stroke-width="3"/><path d="M30 16c0-7.732-6.268-14-14-14S2 8.268 2 16" stroke="#4ED401" stroke-width="3"/></svg>
				</div>
			</div>
		`);
	}
}

export default class LoadMoreObserver {
	constructor(props = {}) {
		this.$root = props.$root;
		this.$container = null;
		this.$trigger = null;
		this.$items = null;

		this.autoinit = props.autoinit === false ? props.autoinit : true;
		this.moreUrl = props.moreUrl;
		this.offset = null;
		this.afterObserve = props.afterObserve || null;

		this.observing = false;
		this.loading = false;

		if (this.autoinit) {
			this.init();
		}
	}

	init() {
		if (this.$root == null || !(this.$root.dataset && this.$root.dataset.observerElem === 'root')) {
			throw new Error('LazyLoadObserver: Root element is not defined!');
		}

		this.$container = this.$root.querySelector('[data-observer-elem="container"]');
		this.$trigger = this.$root.querySelector('[data-observer-elem="trigger"]');
		this.$items = this.$root.querySelectorAll('[data-observer-elem="item"]');

		if (this.moreUrl == null) {
			this.moreUrl = this.$root.dataset.observerUrl;
		}

		if (this.$container != null && this.$trigger != null) {
			this.initObserver();
		}
	}

	reinit() {
		this.$root.insertAdjacentHTML('beforeend', LoadMoreObserverTemplates.spinner());
		this.$trigger = this.$root.querySelector('[data-observer-elem="trigger"]');

		if (!this.observer) {
			this.initObserver();
		} else {
			this.observer.observe(this.$trigger);
			this.observing = true;
		}
	}

	initObserver() {
		this.observer = new IntersectionObserver(entries => {
			const firstEntry = entries[0];

			if (firstEntry.isIntersecting && !this.loading) {
				this.loadHtml();
			}
		}, {
			threshold: 0.75
		});
		this.observer.observe(this.$trigger);
		this.observing = true;
	}

	loadHtml() {
		this.loading = true;
		this.$items = this.$root.querySelectorAll('[data-observer-elem="item"]');
		this.offset = this.$items.length;

		Api.get(this.moreUrl, { offset: this.offset }).then((data) => {
			data = data.trim();

			if (data) {
				this.$container.insertAdjacentHTML('beforeend', data);
				lozadObserver.observe();

				if (this.afterObserve) {
					this.afterObserve();
				}

				this.loading = false;
			} else {
				this.observer.unobserve(this.$trigger);
				this.$trigger.remove();
				this.observing = false;
			}

			this.loading = false;
		});
	}
}